interface SharedBookmark {
  title: string;
  url: string;
}

export function getSharedBookmark(
  search: string = window.location.search,
): SharedBookmark | null {
  const params = new URLSearchParams(search);
  const text = params.get('text') || '';
  // share_target often delivers the URL only inside 'text'
  const url = params.get('url') || text.match(/https?:\/\/\S+/)?.[0] || '';
  if (!url) return null;
  const cleanUrl = url.replace(/[)\].,]+$/, '');
  const title = (params.get('title') || '').trim() || cleanUrl;
  return { title, url: cleanUrl };
}

export function clearSharedTarget(): void {
  history.replaceState(null, '', window.location.pathname);
}
